import { gql } from "@apollo/client";

export const GET_ALL_USER_MANAGEMENT_LIST = gql`
  query AllUserManagementList {
    getAllUserManagementList {
      umd_id
      firstName
      lastName
      email
      active
      groups
      lastlogin
    }
  }
`;

export const GET_ALL_USER_GROUPS = gql`
  query AllUserGroups {
    getAllUserGroups {
    user_group
    group_desc
    is_portal_group
  }
  }
`;

export const GET_USER = gql`
  query GetUser($umdId: String!) {
  getUser(umd_id: $umdId) {
    umd_id
    firstName
    lastName
    phone
    email
    active
    lastlogin
    accountName
    accountDescription
    manager
    section
    accessRequestType
    assignedGroups {
      umd_id
      user_group
      group_desc
      is_portal_group
    }
    assignedLhds {
      umd_id
      lhd_id
      lhd_name
    }
    assignedSystems {
      umdId
      systemId
      systemName
      deqId
    }
    assignedInstitutions {
      umd_id
      institutionId
      institutionName
    }
  }
}
`;

export const UPDATE_USER_DATA = gql`
mutation UpdateUser($input: UpdateUserDataInput!) {
  updateUser(UpdateUserDataInput: $input)
}
`;


 
export const GET_ALL_ROLES_AND_MODULES = gql`
  query {
    getAllRoles {
      value
      label
    }
    getAllModules {
      label
      value
    }
  }
`;

export const GET_ALL_WATER_SYSTEMS = gql`
 query GetWaterSystemMenu {
  getWaterSystemMenu {
    value
    label
  }
  }
`;

export const GET_ALL_INSTITUTIONS = gql`
  query GetAllInstitutions {
  getAllInstitutions {
    umd_id
    institutionId
    institutionName
  }
}
`;

export const GET_ALL_LHD = gql`
  query GetAllLHD {
  getAllLHD {
    umd_id
    lhd_id
    lhd_name
  }
}
`;

export const GET_USER_DETAILS = gql`
  query getUserDetails($umdId: String) {
    getUserDetails(umdId: $umdId) {
      umdId
      firstName
      lastName
      email
      isActive
      isStaff
      isSysAdmin
      isPortalUser
    }
  }
`;

export const GET_USER_ASSIGNMENTS = gql`
  query UserAssignments($umdId: String) {
    getUserAssignmentsRes(umdId: $umdId) {
      moduleCode
      moduleAssigned
      moduleRoute
      roleCode
      roleAssigned
    }
  }
`;
export const GET_LOGGEDIN_USER_QUERY = gql`
  query {
    getLoggedInUser {
      umdId
      email
      firstName
      lastName
      phone
      isActive
      isStaff
      isSysAdmin
      isPortalUser
      assignments {
        umdId
        moduleCode
        moduleAssigned
        moduleRoute
        roleCode
        roleAssigned
      }
      systems {
        systemId
        deqId
      }
      permissions
    }
  }
`;

export const ADD_USER = gql`
  mutation AddUser(
    $umdId: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $phone: String
    $isActive: Boolean!
    $isStaff: Boolean!
    $isSysAdmin: Boolean
    $isPortalUser: Boolean
  ) {
    addNewUser(
      AddUserInput: {
        umdId: $umdId
        email: $email
        firstName: $firstName
        lastName: $lastName
        phone: $phone
        isActive: $isActive
        isStaff: $isStaff
        isSysAdmin: $isSysAdmin
        isPortalUser: $isPortalUser
      }
    ) {
      umdId
      email
      firstName
      lastName
      phone
      isActive
      isStaff
      isSysAdmin
      isPortalUser
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $umdId: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $phone: String
    $isActive: Boolean!
    $isStaff: Boolean!
    $isSysAdmin: Boolean!
    $isPortalUser: Boolean
  ) {
    updateUser(
      UpdateUserInput: {
        umdId: $umdId
        email: $email
        firstName: $firstName
        lastName: $lastName
        phone: $phone
        isActive: $isActive
        isStaff: $isStaff
        isSysAdmin: $isSysAdmin
        isPortalUser: $isPortalUser
      }
    ) {
      umdId
      email
      firstName
      lastName
      phone
      isActive
      isStaff
      isSysAdmin
      isPortalUser
    }
  }
`;

export const ADD_NEW_ASSIGNMENT = gql`
  mutation NewUserAssignment($umdId: String!, $moduleCode: String!, $roleCode: String!) {
    addNewUserAssignment(AddUserAssignmentInput: { umdId: $umdId, moduleCode: $moduleCode, roleCode: $roleCode }) {
      umdId
      moduleCode
      moduleAssigned
      roleCode
      roleAssigned
    }
  }
`;

export const UPDATE_USER_ASSIGNMENT = gql`
  mutation UpdateUserAssignment($umdId: String!, $moduleCode: String!, $roleCode: String!) {
    updateUserAssignment(UpdateUserAssignmentInput: { umdId: $umdId, moduleCode: $moduleCode, roleCode: $roleCode }) {
      umdId
      moduleCode
      moduleAssigned
      roleCode
      roleAssigned
    }
  }
`;

export const DELETE_USER_ASSIGNMENT = gql`
  mutation DeleteUserAssignment($umdId: String!, $moduleCode: String!) {
    deleteUserAssignment(DeleteUserAssignmentInput: { umdId: $umdId, moduleCode: $moduleCode }) {
      umdId
      moduleCode
      moduleAssigned
      roleCode
      roleAssigned
    }
  }
`;
